import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../../context/CartContext';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { totalItems } = useCart();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Home', path: '/' },
    { label: 'Products', path: '/products' },
    { label: 'About Us', path: '/about' },
    { label: 'Contact', path: '/contact' },
  ];

  const isActive = (path: string) =>
    path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-white/80 backdrop-blur-sm'
      }`}
      style={{ fontFamily: "'Quicksand', sans-serif" }}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://storage.readdy-site.link/project_files/6541567e-6f9e-4c0d-a197-6ac1391c9a7a/110f37e5-96e8-4c69-ac75-99d73641fb18_410-DP3---2.png?v=ad04a06fe90851ea0575a478e492e2f4"
            alt="Little Loop Logo"
            className="h-10 object-contain"
          />
        </Link>

        {/* Desktop Nav Links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map(link => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-600 transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                isActive(link.path)
                  ? 'text-brand-yellow'
                  : 'text-gray-600 hover:text-brand-yellow'
              }`}
              style={{ fontWeight: 600 }}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Right Side */}
        <div className="flex items-center gap-4">
          <Link to="/cart" className="relative cursor-pointer flex items-center justify-center w-10 h-10">
            <i className="ri-shopping-basket-line text-2xl text-gray-700 hover:text-brand-yellow transition-colors"></i>
            {totalItems > 0 && (
              <span className="absolute -top-1 -right-1 bg-brand-yellow text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-700" style={{ fontWeight: 700 }}>
                {totalItems}
              </span>
            )}
          </Link>

          {/* Mobile menu toggle */}
          <button
            className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-2xl text-gray-700 ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map(link => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMenuOpen(false)}
              className={`text-sm font-600 py-2 transition-colors cursor-pointer ${
                isActive(link.path) ? 'text-brand-yellow' : 'text-gray-700 hover:text-brand-yellow'
              }`}
              style={{ fontWeight: 600 }}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
